import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ShoppingBagIcon, SearchIcon, FilterIcon, ArrowUpDownIcon, CheckCircleIcon, XCircleIcon, AlertTriangleIcon, TagIcon, TrendingUpIcon, TrendingDownIcon, StarIcon, DollarSignIcon, PhoneIcon, BarChart2Icon, ArrowRightIcon, RefreshCwIcon, HeartIcon, BookmarkIcon, ShieldIcon, CheckIcon, ChevronDownIcon, ExternalLinkIcon, ListFilterIcon } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { Progress } from '@/components/ui/progress';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
const marketplaceListings = [{
  id: 'listing-001',
  title: 'iPhone 13 Pro Max - 256GB',
  description: 'Excellent condition, minor scratches on frame. Includes original box and accessories.',
  price: 749.99,
  originalPrice: 899.99,
  discount: 17,
  condition: 'A Grade',
  source: 'eBay',
  seller: {
    name: 'TechTrade Pro',
    rating: 4.8,
    verified: true,
    transactions: 1243
  },
  location: 'San Francisco, CA',
  postedDate: '2 hours ago',
  quantity: 5,
  image: 'https://images.unsplash.com/photo-1632661674596-df8be070a5c5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1336&q=80',
  tags: ['Trending', 'Deal'],
  priceHistory: [{
    date: '1 week ago',
    price: 799.99
  }, {
    date: '2 weeks ago',
    price: 849.99
  }, {
    date: '1 month ago',
    price: 899.99
  }],
  specifications: {
    storage: '256GB',
    color: 'Graphite',
    carrier: 'Unlocked',
    battery: '92%'
  },
  trending: 'up'
}, {
  id: 'listing-002',
  title: 'Samsung Galaxy S22 Ultra - 128GB',
  description: 'Like new condition, screen protector applied since day one. Comes with fast charger.',
  price: 649.99,
  originalPrice: 799.99,
  discount: 19,
  condition: 'A Grade',
  source: 'Swappa',
  seller: {
    name: 'Mobile Resellers Inc',
    rating: 4.9,
    verified: true,
    transactions: 856
  },
  location: 'Austin, TX',
  postedDate: '5 hours ago',
  quantity: 3,
  image: 'https://images.unsplash.com/photo-1644501635454-a0a4f9eee0ad?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80',
  tags: ['Hot Deal'],
  priceHistory: [{
    date: '1 week ago',
    price: 699.99
  }, {
    date: '2 weeks ago',
    price: 749.99
  }, {
    date: '1 month ago',
    price: 799.99
  }],
  specifications: {
    storage: '128GB',
    color: 'Phantom Black',
    carrier: 'Unlocked',
    battery: '95%'
  },
  trending: 'up'
}, {
  id: 'listing-003',
  title: 'Google Pixel 6 Pro - 256GB',
  description: 'Good condition with minor wear. Screen has been replaced with genuine parts. All functions working perfectly.',
  price: 399.99,
  originalPrice: 499.99,
  discount: 20,
  condition: 'B Grade',
  source: 'Facebook',
  seller: {
    name: 'Pixel Perfect',
    rating: 4.5,
    verified: false,
    transactions: 127
  },
  location: 'Seattle, WA',
  postedDate: '1 day ago',
  quantity: 2,
  image: 'https://images.unsplash.com/photo-1635870723802-e88d76ae3189?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2342&q=80',
  tags: [],
  priceHistory: [{
    date: '1 week ago',
    price: 429.99
  }, {
    date: '2 weeks ago',
    price: 459.99
  }, {
    date: '1 month ago',
    price: 499.99
  }],
  specifications: {
    storage: '256GB',
    color: 'Stormy Black',
    carrier: 'Unlocked',
    battery: '89%'
  },
  trending: 'down'
}, {
  id: 'listing-004',
  title: 'iPhone 12 - 128GB',
  description: 'Fair condition with visible scratches on back glass. Battery health at 85%. No Face ID issues.',
  price: 379.99,
  originalPrice: 429.99,
  discount: 12,
  condition: 'C Grade',
  source: 'WholeCell',
  seller: {
    name: 'Wholesale Phones Direct',
    rating: 4.7,
    verified: true,
    transactions: 3452
  },
  location: 'Miami, FL',
  postedDate: '3 days ago',
  quantity: 8,
  image: 'https://images.unsplash.com/photo-1607936854279-55e8a4c64888?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80',
  tags: ['Bulk Available'],
  priceHistory: [{
    date: '1 week ago',
    price: 399.99
  }, {
    date: '2 weeks ago',
    price: 419.99
  }, {
    date: '1 month ago',
    price: 429.99
  }],
  specifications: {
    storage: '128GB',
    color: 'Blue',
    carrier: 'Unlocked',
    battery: '85%'
  },
  trending: 'stable'
}, {
  id: 'listing-005',
  title: 'OnePlus 10 Pro - 256GB',
  description: 'Excellent condition with original packaging. Includes screen protector and case.',
  price: 499.99,
  originalPrice: 599.99,
  discount: 17,
  condition: 'A Grade',
  source: 'eBay',
  seller: {
    name: 'Premium Devices',
    rating: 4.6,
    verified: true,
    transactions: 782
  },
  location: 'Chicago, IL',
  postedDate: '4 days ago',
  quantity: 1,
  image: 'https://images.unsplash.com/photo-1551355738-1875c6f742dc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2342&q=80',
  tags: ['Limited Stock'],
  priceHistory: [{
    date: '1 week ago',
    price: 529.99
  }, {
    date: '2 weeks ago',
    price: 559.99
  }, {
    date: '1 month ago',
    price: 599.99
  }],
  specifications: {
    storage: '256GB',
    color: 'Emerald Forest',
    carrier: 'Unlocked',
    battery: '97%'
  },
  trending: 'up'
}, {
  id: 'listing-006',
  title: 'iPhone SE (2022) - 64GB',
  description: 'New open box. Never used, just opened to verify contents. Full warranty.',
  price: 329.99,
  originalPrice: 429.99,
  discount: 23,
  condition: 'New',
  source: 'Amazon',
  seller: {
    name: 'Apple Certified Reseller',
    rating: 4.9,
    verified: true,
    transactions: 5241
  },
  location: 'New York, NY',
  postedDate: '6 hours ago',
  quantity: 10,
  image: 'https://images.unsplash.com/photo-1592813630413-9c8a7e54ad5b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80',
  tags: ['Best Value'],
  priceHistory: [{
    date: '1 week ago',
    price: 369.99
  }, {
    date: '2 weeks ago',
    price: 399.99
  }, {
    date: '1 month ago',
    price: 429.99
  }],
  specifications: {
    storage: '64GB',
    color: 'Midnight',
    carrier: 'Unlocked',
    battery: '100%'
  },
  trending: 'down'
}];
const marketplaceStats = {
  totalListings: 1245,
  newToday: 87,
  averageDiscount: '18.2%',
  topPlatform: 'eBay (42%)',
  mostSearched: 'iPhone 13 Pro'
};
const recentDeals = [{
  id: 'deal-001',
  device: 'iPhone 13 Pro Max',
  price: '$749.99',
  discount: '17% off',
  source: 'eBay',
  time: '2 hours ago'
}, {
  id: 'deal-002',
  device: 'Samsung S22 Ultra',
  price: '$649.99',
  discount: '19% off',
  source: 'Swappa',
  time: '5 hours ago'
}, {
  id: 'deal-003',
  device: 'iPhone SE 2022',
  price: '$329.99',
  discount: '23% off',
  source: 'Amazon',
  time: '6 hours ago'
}];
const DealFinder = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOption, setSortOption] = useState('relevance');
  const [selectedFilters, setSelectedFilters] = useState({
    condition: [],
    source: [],
    price: [0, 1000],
    verified: false
  });
  const getSourceColor = source => {
    switch (source) {
      case 'eBay':
        return 'bg-blue-500';
      case 'Swappa':
        return 'bg-purple-500';
      case 'Facebook':
        return 'bg-indigo-500';
      case 'WholeCell':
        return 'bg-pink-500';
      case 'Amazon':
        return 'bg-orange-500';
      default:
        return 'bg-gray-500';
    }
  };
  const getConditionBadge = condition => {
    switch (condition) {
      case 'New':
        return <Badge variant="success" data-id="element-727">New</Badge>;
      case 'A Grade':
        return <Badge variant="success" data-id="element-728">A Grade</Badge>;
      case 'B Grade':
        return <Badge variant="warning" data-id="element-729">B Grade</Badge>;
      case 'C Grade':
        return <Badge variant="default" data-id="element-730">C Grade</Badge>;
      default:
        return <Badge variant="outline" data-id="element-731">{condition}</Badge>;
    }
  };
  const filteredListings = marketplaceListings.filter(listing => {
    if (searchQuery && !listing.title.toLowerCase().includes(searchQuery.toLowerCase())) {
      return false;
    }
    if (activeTab === 'iphone' && !listing.title.toLowerCase().includes('iphone')) {
      return false;
    }
    if (activeTab === 'samsung' && !listing.title.toLowerCase().includes('samsung')) {
      return false;
    }
    if (activeTab === 'google' && !listing.title.toLowerCase().includes('google')) {
      return false;
    }
    if (activeTab === 'other' && (listing.title.toLowerCase().includes('iphone') || listing.title.toLowerCase().includes('samsung') || listing.title.toLowerCase().includes('google'))) {
      return false;
    }
    return true;
  });
  return <div className="space-y-6" data-id="element-732">
      <div className="flex items-center justify-between" data-id="element-733">
        <div data-id="element-734">
          <h1 className="text-2xl font-bold" data-id="element-735">Marketplace</h1>
          <p className="text-sm text-muted-foreground" data-id="element-736">
            Find the best deals across multiple platforms
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-737">
          <Button variant="outline" data-id="element-738">
            <FilterIcon className="mr-2 h-4 w-4" data-id="element-739" />
            Advanced Filters
          </Button>
          <Button variant="outline" data-id="element-740">
            <BookmarkIcon className="mr-2 h-4 w-4" data-id="element-741" />
            Saved Searches
          </Button>
          <Button data-id="element-742">
            <RefreshCwIcon className="mr-2 h-4 w-4" data-id="element-743" />
            Refresh Listings
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-744">
        <Card data-id="element-745">
          <CardContent className="p-4" data-id="element-746">
            <div className="flex items-center justify-between" data-id="element-747">
              <div data-id="element-748">
                <p className="text-sm text-muted-foreground" data-id="element-749">Total Listings</p>
                <p className="text-2xl font-bold" data-id="element-750">
                  {marketplaceStats.totalListings}
                </p>
              </div>
              <ShoppingBagIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-751" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-752">
          <CardContent className="p-4" data-id="element-753">
            <div className="flex items-center justify-between" data-id="element-754">
              <div data-id="element-755">
                <p className="text-sm text-muted-foreground" data-id="element-756">New Today</p>
                <p className="text-2xl font-bold" data-id="element-757">
                  {marketplaceStats.newToday}
                </p>
              </div>
              <TagIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-758" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-759">
          <CardContent className="p-4" data-id="element-760">
            <div className="flex items-center justify-between" data-id="element-761">
              <div data-id="element-762">
                <p className="text-sm text-muted-foreground" data-id="element-763">Avg. Discount</p>
                <p className="text-2xl font-bold" data-id="element-764">
                  {marketplaceStats.averageDiscount}
                </p>
              </div>
              <BarChart2Icon className="h-8 w-8 text-muted-foreground/30" data-id="element-765" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-766">
          <CardContent className="p-4" data-id="element-767">
            <div className="flex items-center justify-between" data-id="element-768">
              <div data-id="element-769">
                <p className="text-sm text-muted-foreground" data-id="element-770">Top Platform</p>
                <p className="text-2xl font-bold" data-id="element-771">
                  {marketplaceStats.topPlatform}
                </p>
              </div>
              <TrendingUpIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-772" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-773">
          <CardContent className="p-4" data-id="element-774">
            <div className="flex items-center justify-between" data-id="element-775">
              <div data-id="element-776">
                <p className="text-sm text-muted-foreground" data-id="element-777">Most Searched</p>
                <p className="text-2xl font-bold" data-id="element-778">
                  {marketplaceStats.mostSearched}
                </p>
              </div>
              <SearchIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-779" />
            </div>
          </CardContent>
        </Card>
      </div>
      <Card data-id="element-780">
        <CardHeader className="pb-2" data-id="element-781">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0" data-id="element-782">
            <CardTitle data-id="element-783">Aggregator Marketplace</CardTitle>
            <div className="relative" data-id="element-784">
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-785" />
              <input type="text" placeholder="Search devices..." className="pl-10 pr-4 py-2 rounded-md border bg-background text-sm w-full sm:w-64" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-786" />
            </div>
          </div>
          <CardDescription data-id="element-787">
            Find the best deals across multiple platforms
          </CardDescription>
        </CardHeader>
        <CardContent data-id="element-788">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-4 space-y-2 sm:space-y-0" data-id="element-789">
            <Tabs defaultValue="all" value={activeTab} onValueChange={setActiveTab} data-id="element-790">
              <TabsList data-id="element-791">
                <TabsTrigger value="all" data-id="element-792">All Devices</TabsTrigger>
                <TabsTrigger value="iphone" data-id="element-793">iPhone</TabsTrigger>
                <TabsTrigger value="samsung" data-id="element-794">Samsung</TabsTrigger>
                <TabsTrigger value="google" data-id="element-795">Google</TabsTrigger>
                <TabsTrigger value="other" data-id="element-796">Other</TabsTrigger>
              </TabsList>
            </Tabs>
            <div className="flex items-center space-x-4" data-id="element-797">
              <div className="flex items-center space-x-2" data-id="element-798">
                <span className="text-sm text-muted-foreground" data-id="element-799">Sort by:</span>
                <select className="border rounded-md bg-background p-1 text-sm" value={sortOption} onChange={e => setSortOption(e.target.value)} data-id="element-800">
                  <option value="relevance" data-id="element-801">Relevance</option>
                  <option value="priceAsc" data-id="element-802">Price: Low to High</option>
                  <option value="priceDesc" data-id="element-803">Price: High to Low</option>
                  <option value="newest" data-id="element-804">Newest</option>
                  <option value="discount" data-id="element-805">Biggest Discount</option>
                </select>
              </div>
              <Button variant="outline" size="sm" data-id="element-806">
                <ListFilterIcon className="h-4 w-4 mr-1" data-id="element-807" />
                Filters
              </Button>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-808">
            {filteredListings.map(listing => <Card key={listing.id} className="overflow-hidden" data-id="element-809">
                <div className="aspect-video w-full relative overflow-hidden" data-id="element-810">
                  <img src={listing.image} alt={listing.title} className="w-full h-full object-cover" data-id="element-811" />
                  <div className="absolute top-2 left-2 flex flex-col space-y-1" data-id="element-812">
                    {listing.discount > 0 && <Badge variant="destructive" data-id="element-813">
                        {listing.discount}% OFF
                      </Badge>}
                    <div className={`px-2 py-0.5 rounded text-xs text-white font-medium ${getSourceColor(listing.source)}`} data-id="element-814">
                      {listing.source}
                    </div>
                  </div>
                  <div className="absolute top-2 right-2" data-id="element-815">
                    <Button variant="ghost" size="icon" className="h-8 w-8 rounded-full bg-background/80 text-foreground" data-id="element-816">
                      <HeartIcon className="h-4 w-4" data-id="element-817" />
                    </Button>
                  </div>
                </div>
                <CardContent className="p-4" data-id="element-818">
                  <div className="flex items-start justify-between mb-1" data-id="element-819">
                    <h3 className="font-medium line-clamp-1" data-id="element-820">
                      {listing.title}
                    </h3>
                    {getConditionBadge(listing.condition)}
                  </div>
                  <p className="text-sm text-muted-foreground line-clamp-2 h-10 mb-2" data-id="element-821">
                    {listing.description}
                  </p>
                  <div className="flex items-end justify-between" data-id="element-822">
                    <div data-id="element-823">
                      <div className="flex items-center" data-id="element-824">
                        <span className="text-xl font-bold" data-id="element-825">
                          ${listing.price}
                        </span>
                        {listing.originalPrice > listing.price && <span className="text-sm text-muted-foreground line-through ml-2" data-id="element-826">
                            ${listing.originalPrice}
                          </span>}
                      </div>
                      <div className="flex items-center text-xs text-muted-foreground mt-1" data-id="element-827">
                        <span data-id="element-828">{listing.quantity} available</span>
                        <span className="mx-1" data-id="element-829">•</span>
                        <span data-id="element-830">{listing.postedDate}</span>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-831">
                      {listing.trending === 'up' && <TrendingUpIcon className="h-4 w-4 text-green-500 mr-1" data-id="element-832" />}
                      {listing.trending === 'down' && <TrendingDownIcon className="h-4 w-4 text-red-500 mr-1" data-id="element-833" />}
                    </div>
                  </div>
                </CardContent>
                <CardFooter className="p-4 pt-0 flex justify-between" data-id="element-834">
                  <div className="flex items-center text-sm" data-id="element-835">
                    <Avatar className="h-6 w-6 mr-1" data-id="element-836">
                      <AvatarFallback data-id="element-837">
                        {listing.seller.name.charAt(0)}
                      </AvatarFallback>
                    </Avatar>
                    <span className="font-medium line-clamp-1 max-w-[120px]" data-id="element-838">
                      {listing.seller.name}
                    </span>
                    {listing.seller.verified && <CheckCircleIcon className="h-3 w-3 text-blue-500 ml-1" data-id="element-839" />}
                  </div>
                  <Button size="sm" data-id="element-840">
                    View Details <ArrowRightIcon className="ml-1 h-3 w-3" data-id="element-841" />
                  </Button>
                </CardFooter>
              </Card>)}
          </div>
          {filteredListings.length === 0 && <div className="flex flex-col items-center justify-center h-60 border rounded-md bg-muted/30" data-id="element-842">
              <SearchIcon className="h-12 w-12 text-muted-foreground/50 mb-4" data-id="element-843" />
              <h3 className="text-lg font-medium mb-2" data-id="element-844">No results found</h3>
              <p className="text-sm text-muted-foreground text-center max-w-md" data-id="element-845">
                We couldn't find any listings matching your search criteria. Try
                adjusting your filters or search terms.
              </p>
              {searchQuery && <Button variant="outline" className="mt-4" onClick={() => setSearchQuery('')} data-id="element-846">
                  Clear Search
                </Button>}
            </div>}
        </CardContent>
        <CardFooter className="border-t flex justify-between" data-id="element-847">
          <div className="text-sm text-muted-foreground" data-id="element-848">
            Showing {filteredListings.length} of {marketplaceListings.length}{' '}
            listings
          </div>
          <Button variant="outline" size="sm" data-id="element-849">
            Load More
          </Button>
        </CardFooter>
      </Card>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-850">
        <Card className="md:col-span-2" data-id="element-851">
          <CardHeader data-id="element-852">
            <CardTitle data-id="element-853">Recent Hot Deals</CardTitle>
            <CardDescription data-id="element-854">
              Latest discounts and special offers
            </CardDescription>
          </CardHeader>
          <CardContent data-id="element-855">
            <div className="space-y-4" data-id="element-856">
              {recentDeals.map(deal => <div key={deal.id} className="flex items-start p-3 border rounded-md" data-id="element-857">
                  <TagIcon className="h-5 w-5 text-blue-500 mr-3 mt-0.5" data-id="element-858" />
                  <div className="flex-1" data-id="element-859">
                    <div className="flex items-center justify-between" data-id="element-860">
                      <p className="font-medium" data-id="element-861">{deal.device}</p>
                      <p className="font-bold text-green-600" data-id="element-862">{deal.price}</p>
                    </div>
                    <div className="flex items-center justify-between mt-1" data-id="element-863">
                      <div className="flex items-center" data-id="element-864">
                        <span className={`px-2 py-0.5 rounded text-xs text-white font-medium ${getSourceColor(deal.source)}`} data-id="element-865">
                          {deal.source}
                        </span>
                        <span className="text-xs text-green-600 ml-2" data-id="element-866">
                          {deal.discount}
                        </span>
                      </div>
                      <p className="text-xs text-muted-foreground" data-id="element-867">
                        {deal.time}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
          </CardContent>
          <CardFooter className="border-t" data-id="element-868">
            <Button variant="outline" size="sm" className="ml-auto" data-id="element-869">
              View All Deals
            </Button>
          </CardFooter>
        </Card>
        <Card data-id="element-870">
          <CardHeader data-id="element-871">
            <CardTitle data-id="element-872">Market Insights</CardTitle>
            <CardDescription data-id="element-873">Price trends and analytics</CardDescription>
          </CardHeader>
          <CardContent data-id="element-874">
            <div className="space-y-4" data-id="element-875">
              <div className="p-4 border rounded-md bg-muted/30" data-id="element-876">
                <h3 className="text-sm font-medium mb-2" data-id="element-877">
                  Price Trend Analysis
                </h3>
                <div className="space-y-2" data-id="element-878">
                  <div className="flex justify-between items-center" data-id="element-879">
                    <span className="text-sm" data-id="element-880">iPhone 13 Pro</span>
                    <div className="flex items-center text-green-600" data-id="element-881">
                      <TrendingDownIcon className="h-4 w-4 mr-1" data-id="element-882" />
                      <span className="text-xs" data-id="element-883">-5.3% (30d)</span>
                    </div>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-884">
                    <span className="text-sm" data-id="element-885">Samsung S22</span>
                    <div className="flex items-center text-red-600" data-id="element-886">
                      <TrendingDownIcon className="h-4 w-4 mr-1" data-id="element-887" />
                      <span className="text-xs" data-id="element-888">-7.8% (30d)</span>
                    </div>
                  </div>
                  <div className="flex justify-between items-center" data-id="element-889">
                    <span className="text-sm" data-id="element-890">Google Pixel 6</span>
                    <div className="flex items-center text-green-600" data-id="element-891">
                      <TrendingDownIcon className="h-4 w-4 mr-1" data-id="element-892" />
                      <span className="text-xs" data-id="element-893">-3.2% (30d)</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4 border rounded-md" data-id="element-894">
                <h3 className="text-sm font-medium mb-2" data-id="element-895">Best Time to Buy</h3>
                <div className="space-y-1 text-sm" data-id="element-896">
                  <div className="flex items-start" data-id="element-897">
                    <CheckIcon className="h-4 w-4 text-green-500 mr-2 mt-0.5" data-id="element-898" />
                    <span className="text-muted-foreground" data-id="element-899">
                      iPhone prices dropping as new model approaches
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-900">
                    <CheckIcon className="h-4 w-4 text-green-500 mr-2 mt-0.5" data-id="element-901" />
                    <span className="text-muted-foreground" data-id="element-902">
                      Samsung S22 reaching price floor
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-903">
                    <CheckIcon className="h-4 w-4 text-green-500 mr-2 mt-0.5" data-id="element-904" />
                    <span className="text-muted-foreground" data-id="element-905">
                      Best deals typically appear on weekends
                    </span>
                  </div>
                </div>
              </div>
              <Button className="w-full" data-id="element-906">
                <BarChart2Icon className="mr-2 h-4 w-4" data-id="element-907" />
                View Full Market Analysis
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
      <Card data-id="element-908">
        <CardHeader data-id="element-909">
          <CardTitle data-id="element-910">Buying Tips</CardTitle>
          <CardDescription data-id="element-911">
            Maximize your marketplace experience
          </CardDescription>
        </CardHeader>
        <CardContent data-id="element-912">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-913">
            <div className="p-4 border rounded-md" data-id="element-914">
              <div className="flex items-center mb-2" data-id="element-915">
                <ShieldIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-916" />
                <h3 className="font-medium" data-id="element-917">Verify Sellers</h3>
              </div>
              <p className="text-sm text-muted-foreground" data-id="element-918">
                Always check seller ratings and transaction history before
                purchasing. Look for verified badges and consistent positive
                feedback.
              </p>
            </div>
            <div className="p-4 border rounded-md" data-id="element-919">
              <div className="flex items-center mb-2" data-id="element-920">
                <PhoneIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-921" />
                <h3 className="font-medium" data-id="element-922">Check IMEI/ESN</h3>
              </div>
              <p className="text-sm text-muted-foreground" data-id="element-923">
                Request IMEI or ESN numbers and verify they\'re clean before
                purchasing. Our risk assessment tool can help identify potential
                issues.
              </p>
            </div>
            <div className="p-4 border rounded-md" data-id="element-924">
              <div className="flex items-center mb-2" data-id="element-925">
                <DollarSignIcon className="h-5 w-5 text-blue-500 mr-2" data-id="element-926" />
                <h3 className="font-medium" data-id="element-927">Compare Across Platforms</h3>
              </div>
              <p className="text-sm text-muted-foreground" data-id="element-928">
                Prices can vary significantly between marketplaces. Our
                aggregator shows you the best deals across all platforms in one
                place.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
};
export default DealFinder;